import React from 'react';
import MainLayout from './components/layouts/MainLayout';
const App = () => {
    return (
        <>
            <MainLayout/>
        </>
    );
};

export default App;
